import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import GetAppOutlinedIcon from '@mui/icons-material/GetAppOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import {axios_tenant} from '../../../../axios';
import { useAppContext } from '../AppContext';
import { toast } from 'react-toastify';

function DownloadMenuItems({ selectedItem, handleCloseContextMenu, showSnackbar ,setActionStatus}) {
  const appData = useAppContext();
  const [isDownloading, setDownloading] = useState(false);

  const handleDownload = async () => {
    try {
      const { folderId, fileId, type } = selectedItem;

      if (type === 'folder' || type === 'file') {
        setDownloading(true);
        setActionStatus(true);
        // Choose the appropriate endpoint based on the item type
        const downloadEndpoint = type === 'folder' ? 'downloadFolder' : 'downloadFile';

        // Trigger the file download directly from the server
        const response = await axios_tenant.get(
          `/collaboration/${downloadEndpoint}/${type === 'folder' ? folderId : fileId}`
          ,
          {
            responseType: 'blob', // Important to handle binary response
          }
        );

        // Extract the file name from the response headers
        const blob = new Blob([response.data], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = response.headers["content-disposition"]?.split("filename=")[1];
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        toast.success('Item successfully downloaded');
      }

      handleCloseContextMenu();
    } catch (error) {
      setActionStatus(false);
      // toast.error('Error downloading item');
      handleCloseContextMenu()
      // Show error snackbar
      // showSnackbar('Error downloading item', true);
    } finally {
      setActionStatus(false);
      setDownloading(false);
      handleCloseContextMenu()
    }
  };

  return (
    <>
      <MenuItem onClick={handleDownload}>
        {isDownloading ? (
          <CircularProgress size={20} style={{ marginRight: 8 }} />
        ) : (
          <GetAppOutlinedIcon fontSize="small" style={{ marginRight: 8 }} />
        )}
        Download
      </MenuItem>
    </>
  );
}

export default DownloadMenuItems;
